import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta';

// Auth
import auth from '@/components/Auth/auth'
import VueCookies from 'vue-cookies'
// import CAR from '@/components/dashboards/car/Dashboard'
import Login from '@/components/Auth/Login.vue'
import Sign_up from '@/components/Auth/Signup'
// import Home from '@/components/Home'
// this is a new way to lazy load routes, i.e. you don't load the routes
// they are needed... However, we have to load some routes for basic functioning
const NotFound = () => import('@/components/NotFound')
const Settings = () => import('@/components/Admin/Settings')
const UserSettings = () => import('@/components/Admin/UserSettings')
const FeedBack = () => import('@/components/Admin/feedback')
const MainCar = () => import('@/components/dashboards/car/mainCar/MainCarDashboard')
const CAR_HELP = () => import('@/components/dashboards/car/mainCar/car_help');
const CAR_ABOUT = () => import ('@/components/dashboards/car/mainCar/about');
const Contact = () => import('@/components/dashboards/car/mainCar/contact');

const UPDATE_LOG = () => import ('@/components/dashboards/car/mainCar/updateLog');
const nhmisAnalysis = () => import('@/components/dashboards/car/mainCar/nhmisAnalysis');
const healthFacilitySurvey = () => import('@/components/dashboards/car/mainCar/healthFacilitySurvey');
const stateProfile = () => import('@/components/dashboards/car/mainCar/stateProfile');

Vue.use(Router);
Vue.use(Meta);

var router =  new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'home',
      // component: Home,
      redirect: '/central_analytics'
    },
    // {
    //   path: '/central_analytics/:sharer',
    //   name: 'central_analytics_with_url_params',
    //   component: MainCar,
    // },
      // {
      //   path: '/login',
      //   name: 'login',
      //   component: Login
      // },


      ////////////////////////////////////////////////////////////////////////////////////////////////////
      // SUB DASHBOARD ROUTES
      {
        path: '/nhmis_analysis',
        name: 'nhmisAnalysis',
        component: nhmisAnalysis
      },
      {
        path: '/health_facility_survey',
        name: 'healthFacilitySurvey',
        component: healthFacilitySurvey
      },
      {
        path: '/state_profile',
        name: 'stateProfile',
        component: stateProfile
      },
      ////////////////////////////////////////////////////////////////////////////////////////////////////



    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/updateLog',
      name: 'updatelog',
      component: UPDATE_LOG
    },
    {
      path: '/signup',
      name: 'signUp',
      component: Sign_up
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        auth.logout()
        next('/')
      }
    },
    {
      path: '/car_dashboard',
      name: 'main_car',
      component: () => MainCar,
      redirect: 'central_analytics',
      // beforeEnter: requireAuth
    },
    {
      path: '/central_analytics',
      name: 'central_analytics',
      component: MainCar,
      // beforeEnter: requireAuth,
    },
    {
      path: '/help',
      name: 'car_help',
      component: CAR_HELP,
      // beforeEnter: requireAuth,
    },
    {
      path: '/about',
      name: 'car_about',
      component: CAR_ABOUT,
      // meta: {
      //   title: 'About MSDAT Dashboard',
      //   metaTags: [
      //     {
      //       name: 'description',
      //       content: 'Description of the multisource data analytics and triangulation dashboard'
      //     },
      //     {
      //       property: 'og:description',
      //       content: 'Description of the multisource data analytics and triangulation dashboard'
      //     }
      //   ]
      // }
    },
    {
      path: '/central_analytics/:ind_vars*/:ind_yr',
      name: 'central_analytics_with_params',
      component: MainCar,
      // beforeEnter: requireAuth,
      props: route => ({
        indicator_variables: route.params.ind_vars,
        indicator_year: parseInt(route.params.ind_yr)
      })
    },
    {  path: '/admin/feedback',
      name: 'feddback',
      component: FeedBack,
      beforeEnter: requireAuth
    },
    {
      path: '/admin/settings',
      name: 'Settings',
      component: Settings,
      // redirect: to => {
      //   getRedirectPath(to.fullPath)
      // },
      beforeEnter: requireAuth
    },
    {
      path: '/admin/user/settings',
      name: 'user_settings',
      component: UserSettings,
      beforeEnter: requireAuth
    },
    { // Always leave this as last one
      path: '*',
      component: NotFound,// () => import('pages/404'),
      meta: { standalone: true }
    }
  ]
})

var locRedirects = {
  "/car_dashboard": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH ICT",
                      "FMOH DPRS MnE", "FMOH Public Health", "NPHCDA ED", "NPHCDA DPRS", "Admin"],
  "/login": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH Public Health", "FMOH ICT",
    "FMOH DPRS MnE", "NPHCDA ED", "NPHCDA DPRS", "NERICC", "Admin", "Guest"],
  "/logout": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH Public Health", "FMOH ICT",
    "FMOH DPRS MnE", "NPHCDA ED", "NPHCDA DPRS", "NERICC", "Admin", "Guest"],
  "/admin/settings": ["Admin"],
  "/dashboard_usage": ["Admin"],
  "/admin/user/settings": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH Public Health", "FMOH ICT",
  "FMOH DPRS MnE", "NPHCDA ED", "NPHCDA DPRS", "NERICC", "Admin", "Guest"]
}

function getRedirectPath(toFullPath) {
  // ensure that the user has the permission to view the redirect page
  var red_path = toFullPath;
  var red_locs = locRedirects[red_path]; // allowed redirect locations for the redirect path

  var red_path_found = false;
  // red_locs.map( (elem, index) => {
  //   if (elem === auth.getLocation()) {
  //     red_path_found = true;
  //   }
  // })

  // Check if user has permission to access the route he seeks
  if (red_locs.indexOf(auth.getLocation()) > -1) {
    red_path_found = true;
  }

   // Check the route he has permission to access
  if (! red_path_found) {
    // user has no permission to access the route he seeks
    for (var loc in locRedirects) {
      if (locRedirects.hasOwnProperty(loc)) {
        if (locRedirects[loc].indexOf(auth.getLocation()) > -1) {
          red_path = loc; // send user to the route he has permission for.
          red_path_found = true
          break;
        }
      }
    }
    // user has no right to access the redirect path, send user to the route he has permission to : user is Guest
    if (!red_path_found) {
      red_path = '/nhmis_reporting'
    }
  }
  return red_path;
}

function requireAuth (to, from, next) {

  if (to === from){
    next(false);
  }
  // get the appropriate redirect path for the user.
  // var red_path = getRedirectPath(to.fullPath)
  // console.log(auth.getLocation(), red_path, to.fullPath);
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    // to.fullPath = getRedirectPath(red_path)
    //  router.push(red_path);
    // var red_path = getRedirectPath(to.fullPath)
    // console.log(typeof red_path);
    // '/nhmis_reporting'
    next()
  }
}

// You can define an after each property on each every route
// router.afterEach((to, from) => {
//   let pathArray = to.path;
//   pathArray = pathArray.split('_');
//   console.log(pathArray)
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js